import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appInfoReducer from 'features/app-info/slice';
import authReducer from 'features/auth/slice';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const store = configureStore({
  reducer: {
    baseApi: baseApi.reducer,
    appInfo: appInfoReducer,
    auth: authReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
